import styled from 'styled-components';

export const StyledIdeas = styled.div`
  padding-bottom: 20px;

  .ant-select-lg .ant-select-selector .ant-select-selection-item {
    color: ${({ theme }) => theme.brand08};
  }

  .ideas_heading {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .search_title {
    margin-top: 10px;
    margin-bottom: 0.5rem;
  }

  .ideas_search {
    .ant-form-item {
      width: 100%;
    }

    .ant-input::placeholder {
      font-size: ${({ theme }) => theme.p1Size};
    }
  }
  .ideas_select {
    margin-top: 10px;
    margin-bottom: 10px;

    .ant-select-item {
      &.realized {
        color: ${({ theme }) => theme.statusViolet};
        background-color: ${({ theme }) => theme.statusVioletLight};
      }

      &.answered {
        color: ${({ theme }) => theme.statusGreen};
        background-color: ${({ theme }) => theme.statusGreenLight};
      }
    }

    .ant-tag.status {
      border: none;
      border-radius: 10px;
    }

    .ant-tag.status,
    .ant-tag.status span {
      font-weight: 700;
      font-size: ${({ theme }) => theme.p3Size};
      padding: 3px 6px;
    }
  }

  .project_list {
    margin-bottom: 20px;

    .status {
      display: flex;
      align-items: center;
      color: ${({ theme }) => theme.brand07};
      font-size: ${({ theme }) => theme.p3Size} !important;
      background-color: ${({ theme }) => theme.brand07Light};
      padding: 2px 10px;
      border-radius: 16px;
      max-height: 24px;
      font-weight: ${({ theme }) => theme.fontWeightBolder};
    }
  }
`;
